{
	"title": "{{plant}} {{year}} – Adjust carbon balance",
	"description": "Please enter the amount of carbon reductions to be deducted from the buffer to adjust the carbon bank balance and provide a comment explaining the reason for the adjustment.",
	"fossilAmountLabel": "Fossil amount (kg CO₂)",
	"biogenicAmountLabel": "Biogenic amount (kg CO₂)",
	"remainingFossilBuffer": "Remaining fossil buffer",
	"remainingBiogenicBuffer": "Remaining biogenic buffer",
	"co2Unit": "kg CO₂ ep.",
	"reasonLabel": "Reason for adjustment",
	"reasonHint": "Please describe the reason for the adjustment.",
	"fetchError": "Could not load the remaining buffer. Please try again.",
	"warning": "During the annual assurance process, the assurance body will review all balance adjustments. Prior to making any adjustments, it is mandatory to contact the assurance body to discuss the proposed changes.",
	"closeWarning": "Dismiss warning",
	"approvalLabel": "I hereby confirm that this adjustment has been approved by the assurance body.",
	"cancel": "Cancel",
	"adjustBalance": "Adjust carbon balance",
	"adjustSuccess": "The carbon balance adjustment was submitted.",
	"adjustError": "Could not submit the carbon balance adjustment. Please try again."
}
